import { FC } from "react"
import { SafetiesInfo } from "../../../module/safeties/containers/info"

export const SafetiesInfoPage: FC = () => <SafetiesInfo />
